import { render, staticRenderFns } from "./SearchBoxNaturezaOperacao.vue?vue&type=template&id=5a7b8cb1&scoped=true"
import script from "./SearchBoxNaturezaOperacao.vue?vue&type=script&lang=js"
export * from "./SearchBoxNaturezaOperacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7b8cb1",
  null
  
)

export default component.exports